var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isShown
    ? _c("transition-group", { ref: "container", attrs: { name: "modal" } }, [
        _c(
          "div",
          {
            key: _vm.scopeId,
            ref: "modal",
            staticClass: "vuedal modal",
            attrs: { tabindex: "-1", role: "dialog" },
            on: {
              mousedown: function($event) {
                if ($event.target !== $event.currentTarget) {
                  return null
                }
                return _vm.onBlur($event)
              }
            }
          },
          [
            _c(
              "div",
              {
                staticClass: "modal-dialog",
                class: _vm.sizeClasses[_vm.size],
                attrs: { role: "document" }
              },
              [
                _c(
                  "div",
                  { staticClass: "modal-content", style: _vm.modalStyle },
                  [
                    _vm.loading
                      ? _c("div", { staticClass: "loading-wrapper" }, [
                          _c("i", {
                            staticClass: "fa fa-spinner fa-pulse fa-3x fa-fw"
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "sr-only" }, [
                            _vm._v("Loading...")
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "loading-overlay" })
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "modal-header" },
                      [
                        _vm._t("modal-title"),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "close",
                            attrs: { type: "button", "aria-label": "Close" },
                            on: { click: _vm.hide }
                          },
                          [
                            _c("span", { attrs: { "aria-hidden": "true" } }, [
                              _vm._v("×")
                            ])
                          ]
                        )
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "modal-body" },
                      [_vm._t("modal-body")],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "modal-footer" },
                      [_vm._t("modal-footer")],
                      2
                    )
                  ]
                )
              ]
            )
          ]
        ),
        _vm._v(" "),
        _vm.rootModal
          ? _c("div", {
              key: _vm.scopeId + "-backdrop",
              staticClass: "modal-backdrop show",
              on: { click: _vm.onBlur }
            })
          : _vm._e()
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }